<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop"/>
      <b-container fluid>
        <b-row>
          <b-col md="10" offset-md="1">
            <back-button></back-button>
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <div v-if="details.direction === '0'">
                    <img src='../../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                    {{ $t('received.rcvd_verb_past_DP') }}
                  </div>
                  <div v-if="details.direction === '1'">
                    <img src='../../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    {{ $t('sent.snt_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                </h4>
              </div>

              <!-- New Component here -->
              <!-- Needs : details -->
              <direct-payment-details :payment="details" :showMainDetails="true"></direct-payment-details>

              <form-accordion :title="$t('common.formsSubTitle.dir_pymnt_val_hstry')" v-if="details.validators.length > 0">
                <div class="form-group row">
                  <div class="col-12">
                    <table class="table table-striped table-bordered table-status-history">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">{{$t('common.group_label')}}</th>
                          <th scope="col">{{$t('common.vldt_user')}}</th>
                          <th scope="col">{{$t('common.date_vldt')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="validator in sortedValidators" :key="validator.groupLabel">
                          <td class="longword dateTimehistoryHeight">{{validator.groupLabel}}</td>
                          <td class="longword dateTimehistoryHeight">
                            {{validator.identifier}}
                          </td>
                          <td class="showLargeScreenOnly dateTimehistoryHeight" style="padding-right: 30px;">{{validator.horodatage | formatDateTime}}</td>
                          <td class="showSmallScreenOnly">{{validator.horodatage | formatDateTime}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </form-accordion>
            </div>
          </b-col>
        </b-row>


        <!-- comment: Buttons -->
        <div v-if="details.direction === '0' && details.status === '0'" class="inboxDetailButton">
          <div class="row justify-content-start">
            <div class="offset-md-5 col-md-3" style="margin-top: 10px;">
              <button round
              class="button-action firstButtonMarginTop milkyBlockBlack"
              @click="answerDP(true)"
              :disabled="!canAccept">
              <i class="icon fa fa-paper-plane"></i>
                {{ $t('common.accpt') }}
              </button>
            </div>
            <div class="col-md-3" style="margin-top: 10px;">
              <button round
              class="button-action firstButtonMarginTop milkyBlockBlack"
              @click="answerDP(false)"
              :disabled="!canRefuse">
                <i class="icon fa fa-hand-stop-o"></i>
                {{ $t('common.refus') }}
              </button>
            </div>
          </div>
        </div>



      </b-container> <!-- End Container Fluid -->
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
    <!-- </f7-page> -->
  <!-- </div> -->
</template>

<script>
// import base64url from 'base64url'
import moment from 'moment'

import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import backButton from '@/components/common/backButton.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'

import DPdetailsCapsule from '@/pages/requests/detailPages/directPaymentDetailPages/DPdetailsCapsule.vue'


import {errorMessageAlert} from '@/helpers/alert'
import {reloadPage} from '@/helpers/routing'

export default {
  name: 'directPayments-details',
  props: ['direction'],
  components: {
    'back-button': backButton,
    'bottom-toolbar': bottomToolbar,
    'direct-payment-details': DPdetailsCapsule,
    'form-accordion': FormAccordion,
    'page-nav-bar': pageNavBar
  },
  data () {
    return {
      canAccept: false,
      canRefuse: false
    }
  },
  created () {
    this.canAccept = this.$engine.rights.rightIs('dp_response_accepter', true)
    this.canRefuse = this.$engine.rights.rightIs('dp_response_refuser', true)
    // if (this.direction === '0') {
    //   this.details = this.$engine.services.directPayments.currentInbox
    // } else {
    //   this.details = this.$engine.services.directPayments.currentSendbox
    // }
    console.log('DP', this.details)
    this.zoneData = this.$engine.bankAccounts.getZoneData(this.details.creditorZoneCode)
    console.log(this.details.validators)
  },
  methods: {
    answerDP (doesAccept) {
      let that = this
      that.$engine.services.directPayments.answerDP(
        that.details.creditorIdentifier,
        that.details.creditorName,
        that.details.creditorBankAccount,
        that.details.debtorIdentifier,
        that.details.debtorName,
        that.details.debtorBankAccount,
        doesAccept ? 'ACSP' : 'RJCT',
        '',
        that.details.amount,
        that.details.currency,
        that.details.requestedExecutionDate,
        that.details.reason,
        that.details.endToEndId,
        that.details.id,
        that.details.creditorZoneCode,
        that.details.debtorZoneCode
      ).then(response => {
        that.$f7.alert('', doesAccept ? that.$t('directPayments.dp_accepted') : that.$t('directPayments.dp_refused'))
        reloadPage(that, {url: '/inbox/0/'})
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    }
  },
  computed: {
    details () {
      return this.$settings.clickedMessage
    },
    sortedValidators () {
      return this.details.validators.sort((v2, v1) => moment(v1.horodatage, 'YYYY-MM-DDTHH:mm:ss').diff(moment(v2.horodatage, 'YYYY-MM-DDTHH:mm:ss')))
    }
  }
}
</script>
<style scoped>
	.transaction-info {
		/* padding-top: 50px; */
		padding-left: 3%;
		padding-right: 3%;
		width: 94%;
		/* height: 100%; */
		max-height: 100%;
		clear: both;
		margin: 0 auto;
	}
	.modify-actions {
	}
	.changesGrid {
		border-top: 2px solid #fffdb7;
		border-bottom: 2px solid #fffdb7;
		font-weight: bold;
		text-align: center;
		background-color: #fffdb7;
	}
	.firstGridModif {
		border-top: 1px solid #E36608;
		border-bottom: 1px solid #E36608;
		font-weight: bold;
		text-align: center;
		border-radius: 0px 0px 0 0;
		margin-top: 3%;
	}
	.titleGridModif {
		color: #ffffff;
		background-color: #E36608;
		border-radius: 0px 0px 0 0;
	}
	.defaultGridDisplayModif {
		border-left: 2px solid orange;
		border-right: 2px solid orange;
		background-color: #ffffff;
	}
	.lastGridModif {
		border-bottom: 1px solid #12bcf1;
	}
  .zeroHight {
    height: 0px;
  }
  .titleGridExecuted {
    color: #ffffff;
		background-color: #46C03D;
		border-radius: 0px 0px 0 0;
  }
  .subTitlePaymentsInfo {
    color: #000000;
    /* padding: 3px 0px 9px 1%; */
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .iconDetailsPage {
    font-size:15px;
    padding-left:5px;
  }
  .colorRemittanceInfomation {
    color:#144a85
  }
  .bankAccountPaymentsSelectionList {
    /* display: none;
    position: absolute;
    background-color: #f9f9f9; */
    margin:0px;
    list-style: none;
    padding-left: 0 !important;
    max-height: 96px;
    overflow:hidden;
    overflow-y:scroll;

    /* -webkit-appearance: none;
    width: 7px; */
  }
  .bankAccountPaymentsSelectionListContainer{
    display: none;
    position: absolute;
    right: 10px;
    top: 25px;
    /* bottom: 0px; */
    margin-top: 1px;
    background-color: #ffffff;
    border: 1px solid #a9a9a9;
    min-width: 206px;
    z-index: 20;
  }
  .bankAccountPaymentsSelectionInput {
    /* width: 215px; */
    font-size: 12px !important;
    height: auto !important;
    width: 190px !important;
  }
  .bankAccountPaymentsSelectionListItem {
    padding: 8px 8px;
  }
  .closeSelectionListContainerLabel {
    padding: 3px 8px 3px 8px;
    /* text-align: right; */
    /* height: 29px; */
    border-bottom: 1px solid #a9a9a9;
  }
  .rightButton {
    /* float: right; */
    right: 8px;
    top: 3px;
    /* width: 60px; */
    padding: 1px 5px !important;
    position: absolute;
    line-height: normal !important;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
  .closeSelectionListContainerLabelName {
    line-height: 21px;
  }
  .pain001ViewerBlock {
    display: block !important;
  }
  .pain001ViewerButtonBlock {
    margin-right: 7px !important;
    float: right !important;
    position: relative !important;
    color: #777777;
  }
	/*.button {
		margin-top: 5px;
		margin-bottom: 5px;
	}*/
  .transactionDetailFontSize {
    font-size: 16px !important;
  }
  .transactionDetailHeader{
    color:white;
    background-color: #12bcf1;
    text-align: center;
    font-size: 14px;
    display: block;
    min-height: 0 !important;
    padding: 8px 15px !important;
    /* font-weight: bold; */
  }
  .transactionDetailSubHeader {
    text-align: center !important;
    display: block !important;
    font-weight: bold !important;
  }
  .icon-transaction-detail {
    width: 18px;
    height: 18px;
    background-size: contain;
  }
  .headerChevron {
    float: right;
    font-size: 12px;
    margin-top: 4px;
  }
  .list-block li {
    background-color: #fcfcfc;
  }
  .list-block.item-content {
    padding-left: 0% !important;
  }
  .list-block.inset {
    margin-left: 0%;
  }
</style>
